import React, { memo } from "react";
import { useThemeColor } from "../hooks/useThemeColor";

const CircleOverlay = memo(({ index }) => {
  const themeColor = useThemeColor(index);
  return (
    <div
      className="w-[650px] h-[650px] rounded-full blur-[250px]"
      style={{ backgroundColor: themeColor }}
    ></div>
  );
});

CircleOverlay.displayName = 'CircleOverlay';

export default CircleOverlay;
